<template>
  <v-container fluid>
    <template>
      <v-card class="mt-4">
        <v-card-title>
          <h4 class="subheading grey--text">Φίλτρα</h4>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Αναζήτηση"
                single-line
                clearable
                hide-details
              ></v-text-field>
            </v-col> 
            <v-col>
              <v-text-field
                v-model="searchSku"
                append-icon="mdi-tag"
                label="Κωδικός"
                single-line
                clearable
                hide-details
              ></v-text-field>
            </v-col>
            <v-col >
               <v-select
                  :items=partCategories
                  label="Κατηγορία Ανταλλακτικού"
                  v-model="category"
                  :hint="`Cat-ID: ${category}`"
                  persistent-hint
                  item-text="Description"
                  item-value="CatId"
                  clearable
                ></v-select>
            </v-col>
            <v-col>
              <v-combobox
                v-model="manf"
                :items="uniqueManufacturers"
                prepend-icon="mdi-factory"
                label="Κατασκευαστής"
                chips
                multiple
                clearable
              >
                <template v-slot:selection="{ attrs, item, select, selected }">
                  <v-chip
                    v-bind="attrs"
                    :input-value="selected"
                    close
                    @click="select"
                    @click:close="remove(manf, item)"
                  >
                    <strong>{{ item }}</strong
                    >&nbsp;
                  </v-chip>
                </template>
              </v-combobox>
            </v-col>
          </v-row>

        </v-card-text>
      </v-card>
    </template>

  <template>
  <v-card class="ma-0 mt-4"
    :loading="loading"
    >
    <v-card-title>
       <h1 class="mr-2 subheading grey--text">Λίστα Παραγγελιών</h1>
       <v-spacer/>
      <v-btn icon @click="toggleBarcodeInput">
        <v-icon>mdi-barcode-scan</v-icon>
      </v-btn>
          <v-text-field
            v-if="showBarcodeInput"
            v-model="barcode"
            label="Scan Barcode"
            @keyup.enter="checkBarcode"
            hide-details
            dense
            class="barcode-text-field"
            ref="barcodeInputField"
          ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="computedHeaders"
      :items="filteredOrders"
      loading: false
      :search="search"
      item-key="Id"
      class="elevation-1"
      :loading="loading"
      sort-desc
      sort-by="Id"
      show-group-by
      loading-text="Loading... Please wait"
    >
 <template
        v-slot:group.header="{ group, groupBy, items, isOpen, toggle, remove }"
      >
        <th colspan="10">
          <v-icon @click="toggle"
            >{{ isOpen ? "mdi-minus" : "mdi-plus" }}
          </v-icon>
         <v-chip  v-if="groupBy=='FmSku'" text-color="white" color="light-blue" text>SKU {{ group }}</v-chip> 
         <v-chip  v-else color="primary">{{ group }}</v-chip> 
          <v-chip round color="light-blue darken-1" text-color="white">Ποσότητα: {{ $sumField(items, "StockQty") }}</v-chip>
          <v-icon @click="remove">mdi-close </v-icon>
        </th>
   </template>
        
   <template v-slot:item.ScannedQty="{ item }">
    <v-chip
      :color="getScannedQtyColor(item)"
      text-color="white"
    >
      <v-icon
        left
        @click="resetItemScannedQty(item)"
      >
        {{ getScannedQtyIcon(item) }}
      </v-icon>
      {{ item.ScannedQty || 0 }}
    </v-chip>
</template> 
    <template v-slot:item.actions="{ item }">
        <v-btn
          icon
          small
          :to="{name: 'order-info', params: {id: item.Id}}"
        >
         <v-icon>mdi-dolly</v-icon>
        </v-btn>
         <v-btn
          icon
          small
          :to="{name: 'part-info', params: {id: item.PartId}}"
        >
         <v-icon>mdi-package-variant</v-icon>
        </v-btn>
          <v-btn
          v-if="item.Invoice"
          icon
          small
          :to="{name: 'distributor-order-checkin', params: {invoiceId: item.Invoice.Id}}"
        >
         <v-icon>mdi-file-document</v-icon>
        </v-btn>
     </template>

    <template v-slot:item.Timestamp="{ item }">
       {{ item.Timestamp.split('T')[0] }}
    </template>
     <template v-slot:item.CategoryId="{ item }">
       {{ partCategories.find(i => i.CatId === item.CategoryId).Description }}
    </template>

    <template v-slot:body.append="{ headers }">
      <tr>
        <td v-for="(header, i) in headers" :key="i">
          <div class="text-right" v-if="header.value == 'StockQty'">
          {{ totalStockQty }}
          </div>
          <div class="text-right" v-if="header.value == 'ScannedQty'">
            <v-chip
            :color="totalScannedQtyColor"
            text-color="white"
            >
            <v-icon left @click="resetScannedQty">
              {{ totalScannedQtyIcon }}
            </v-icon>
            {{ totalScannedQty || 0 }}
          </v-chip>
          </div>
          <div v-else>
            <!-- empty table cells for columns that don't need a sum -->
          </div>
        </td>
      </tr>
    </template>    

    </v-data-table>
  </v-card>
</template>

</v-container>
</template>

<script>


export default {
  computed: {
    totalStockQty() {
        return this.filteredOrders.reduce((sum, item) => sum + (item.StockQty || 0), 0);
    },
    totalScannedQty() {
        return this.filteredOrders.reduce((sum, item) => sum + (item.ScannedQty || 0), 0);
    },
    isAdmin() {
        if (!this.$store.state.authentication.user) return false;
        return this.$store.state.authentication.user.scopes.includes("income");
    },
    uniqueManufacturers() {
      // Filter manufacturers by category and search term
      const filteredOrders = this.parts.filter(part => {
        // Filter by category
        const categoryMatch = !this.category || part.CategoryId === this.category;
        // Filter by search term
        const searchMatch = !this.search || part.Description.toLowerCase().includes(this.search.toLowerCase());

        return categoryMatch && searchMatch;
      });

      // Return unique manufacturers
      return this.uniq(filteredOrders, "Manufacturer");
    },
    filteredOrders() {
      return this.parts.filter(part => {
        // Filter by category
        const categoryMatch = !this.category || part.CategoryId === this.category;

        // Filter by search term
        const searchMatch = !this.search || part.Description.toLowerCase().includes(this.search.toLowerCase());
        const searchSku = !this.searchSku || part.FmSku.includes(this.searchSku);
        const searchSupSku = !this.searchSku || part.SupplierSku.includes(this.searchSku);

        // Filter by manufacturer
        const manufacturerMatch = this.manf.length === 0 || this.manf.includes(part.Manufacturer);

        // Combine all filters
        return categoryMatch && searchMatch && manufacturerMatch && (searchSku || searchSupSku);
      });
    },
   computedHeaders() {
    if (!this.showBarcodeInput) {
      return this.headers.filter(header => header.value !== 'ScannedQty');
    }
    return this.headers;
  },
  totalScannedQtyColor() {
    if (this.totalScannedQty > this.totalStockQty) {
      return 'orange'; // Assuming 'orange' is used for warnings
    } else if (this.totalScannedQty == this.totalStockQty) {
      return 'green';
    } else if (this.totalScannedQty > 0) {
      return 'amber';
    } else {
      return 'red';
    }
  },
  totalScannedQtyIcon() {
      // Logic to determine which icon to display
      if (this.totalScannedQty == this.totalStockQty) {
        return 'mdi-check-circle'; // Example icon for high quantity
      } else if ((this.totalScannedQty || 0) == 0 ) {
        return 'mdi-close-circle'; // Example icon for zero quantity
      } else if (this.totalScannedQty < this.totalStockQty ) {
        return 'mdi-alert-circle'; // Example icon for medium quantity
      } else {
        return 'mdi-alert-circle'; // Example icon for medium quantity
      }
    }

},
data() {
  return {
    menu: false,
    expanded: [],
    checkoutdialog: false,
    partQty: 0,
    loading: true,
    partCategories: [],
    search: '',
    searchSku: '',
    inStock: false,
    parts: [],
    manf: [],
    category: null,
    supplier: null,
    showBarcodeInput: false,
    barcode: '',
    labelItem: null, // Item for which the label is being generated
    uniqueSuppliers: [],
    rules:  {
      partId: value => {
          const pattern = /^\d{1,5}$/
          return pattern.test(value) || 'Invalid Part-ID.'
        },
    },
    headers: [
          {
          text: 'Α/Α',
          align: 'start',
          //sortable: false,
          value: 'Id',
          width: '5%',
        },
          { text: 'Ημ/νια', value: 'Timestamp', align: 'start' },
        {
          text: 'Κωδικός',
          align: 'start',
          //sortable: false,
          value: 'FmSku',
          width: '5%',
        },
        {
          text: 'Κωδικός Προμηθευτή',
          align: 'start',
          //sortable: false,
          value: 'SupplierSku',

          width: '5%',
        },
        { text: 'Κατηγορία', value: 'CategoryId', groupable: false, width: '5%'},
        { text: 'Κατασκευαστής', value: 'Manufacturer', groupable: true, width: '20%'},
        { text: 'Περιγραφή', value: 'Description', groupable: false, width: '50%'},

        { text: 'Ελεγχος', value: 'ScannedQty', align: 'end', groupable: false },
        { text: 'Απόθεμα', value: 'StockQty', align: 'end', groupable: false },
        { text: 'Τοποθεσία', value: 'Location', align: 'end', groupable: true },
        { text: 'Actions', value: 'actions', groupable: false, width: '25%' },
      ],
    }
  },
  async created() {
      try {
        const response = await this.$api.get('/inventory/stock-take');
        // console.log(response);
        this.parts = response.data;
        const catresponse = await this.$api.get('/inventory/parts/categories');
        // console.log(response);
        this.partCategories = catresponse.data;
        this.uniqueSuppliers = this.uniqSup(this.parts);
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },
watch: {
      timdialog (val) {
        val || this.close()
      },
},
  methods: {
  tocurr(value) {
    return new Intl.NumberFormat("el-GR", {
      style: "currency",
      currency: "EUR",
    }).format(value.toFixed(2));
  },

  uniqSup(items) {
    //Store the unique
    let uniques = [];

    //Track the items added to the uniques
    let itemsFound = {};
    let supp = null;
    for (let val of items) {
      //If no invoice, skip
      if (~val["Invoice"]) continue;
      //If item is already added then move to the next item
      supp = val["Invoice"]["Supplier"]
      if (itemsFound[supp.Id]) {
        continue;
      }

      //Else push it to the unique list
      uniques.push(supp);

      //Mark it as added
      itemsFound[supp.Id] = true;
    }

    //Return the uniques
    return uniques;
  },
  uniq(items, key) {
    //Store the unique
    let uniques = [];

    //Track the items added to the uniques
    let itemsFound = {};
    for (let val of items) {
      //If item is already added then move to the next item
      if (itemsFound[val[key]]) {
        continue;
      }
      //Else push it to the unique list
      uniques.push(val[key]);

      //Mark it as added
      itemsFound[val[key]] = true;
    }

    //Return the uniques
    return uniques;
  },
  remove(obj, item) {
    obj.splice(obj.indexOf(item), 1);
    obj.manf = [...obj];
  },
 toggleBarcodeInput() {
      this.showBarcodeInput = !this.showBarcodeInput;
      if (this.showBarcodeInput) {
        this.$nextTick(() => {
          this.$refs.barcodeInput.focus();
        });
      }
    },
checkBarcode() {

    const barcodeInput = this.$refs.barcodeInputField;
    const barcode = barcodeInput ? barcodeInput.$el.querySelector('input').value.trim() : '';
    // const barcode = this.barcodeInput.trim();
    barcodeInput.$el.querySelector('input').value = ''; // Clear the input field after checking

    let bid = null;
    if (barcode.startsWith('OIC-')) {
      bid = barcode.substring(4);
      this.updateScannedQty(bid)
    } else {
      bid = parseInt(barcode, 10);
      this.updateScannedQty(bid)
    }
  },
  updateScannedQty2(barcode) {
    // Logic to update scanned quantity based on barcode
    const item = this.parts.find(order => order.Id === parseInt(barcode, 10));
    if (item) {
      item.ScannedQty = (item.ScannedQty || 0) + 1;
    }
  },
   updateScannedQty(barcode) {
      const itemIndex = this.parts.findIndex(order => order.Id === parseInt(barcode, 10));
      if (itemIndex !== -1) {
        // Directly update the item
        this.parts[itemIndex].ScannedQty = (this.parts[itemIndex].ScannedQty || 0) + 1;
        
        // Optionally, reassign the array to itself to ensure reactivity
        this.parts = [...this.parts];
      }
    },
    resetItemScannedQty(item) {
      const itemIndex = this.parts.findIndex(order => order.Id === item.Id);
      if (itemIndex !== -1) {
        // Directly update the item
        this.parts[itemIndex].ScannedQty = 0;
        
        // Optionally, reassign the array to itself to ensure reactivity
        this.parts = [...this.parts];
      }
    },
    resetScannedQty () {
      this.filteredOrders.forEach(element => {
        element.ScannedQty = 0;
      });
    },
  getScannedQtyColor(item) {
    if (item.ScannedQty > item.StockQty) {
      return 'orange'; // Assuming 'orange' is used for warnings
    } else if (item.ScannedQty == item.StockQty) {
      return 'green';
    } else if (item.ScannedQty > 0) {
      return 'amber';
    } else {
      return 'red';
    }
  },
  getScannedQtyIcon(item) {
      // Logic to determine which icon to display
      if (item.ScannedQty == item.StockQty) {
        return 'mdi-check-circle'; // Example icon for high quantity
      } else if ((item.ScannedQty || 0) == 0 ) {
        return 'mdi-close-circle'; // Example icon for zero quantity
      } else if (item.ScannedQty < item.StockQty ) {
        return 'mdi-alert-circle'; // Example icon for medium quantity
      } else {
        return 'mdi-alert-circle'; // Example icon for medium quantity
      }
    }
  }
}
</script>
